import { render, staticRenderFns } from "./OfficeChoice.vue?vue&type=template&id=28ed048f&"
import script from "./OfficeChoice.vue?vue&type=script&lang=js&"
export * from "./OfficeChoice.vue?vue&type=script&lang=js&"
import style0 from "./OfficeChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports